import { Core, Decorative } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import styled from "styled-components";
export var BannerContainer = styled(Flex).attrs({
    align: "center",
    justify: {
        mobileAndAbove: "normal",
        tabletAndAbove: "space-between"
    },
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-f8656eaa-0"
})([
    "width:100%;max-width:1024px;",
    "{height:446px;padding:",
    ";}",
    "{height:640px;padding:",
    ";}",
    "{max-width:1104px;}"
], responsiveMediaQueries.tabletAndAbove, getSpacing("8x", "7x", "6x"), responsiveMediaQueries.desktopAndAbove, getSpacing("4x", 0), responsiveMediaQueries.xLargeAndAbove);
export var BannerWrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-f8656eaa-1"
})([
    "width:100%;background-color:",
    ";& + &{",
    "{",
    "{padding:",
    ";}",
    "{height:640px;padding:",
    ";}}}"
], function(props) {
    return props.$isPhoneSupportSection ? Core.surface.inverse : Decorative.tint.teal;
}, BannerContainer, responsiveMediaQueries.tabletAndAbove, getSpacing(0, "7x", "6x"), responsiveMediaQueries.desktopAndAbove, getSpacing(0, 0, "4x"));
export var BannerImageWrapper = styled(Column).attrs({
    justify: "center"
}).withConfig({
    componentId: "sc-f8656eaa-2"
})([
    "position:relative;order:1;width:100%;",
    "{order:2;width:unset;}"
], responsiveMediaQueries.tabletAndAbove);
export var BannerImage = styled.img.withConfig({
    componentId: "sc-f8656eaa-3"
})([
    "width:100%;height:auto;",
    "{width:auto;height:334px;}",
    "{height:500px;}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove);
export var BannerImageCaption = styled(Typography).attrs({
    color: Core.text.inverse,
    variant: "labelSansRegular"
}).withConfig({
    componentId: "sc-f8656eaa-4"
})([
    "&&&{",
    ";position:absolute;display:none;padding:12px;bottom:0px;right:0px;",
    "{display:block;}}"
], function(param) {
    var $isLeftAligned = param.$isLeftAligned;
    return $isLeftAligned ? "left: 0px" : "right: 0px";
}, responsiveMediaQueries.tabletAndAbove);
export var BannerContentWrapper = styled(Column).withConfig({
    componentId: "sc-f8656eaa-5"
})([
    "padding:",
    ";order:2;",
    "{padding:",
    ";order:1;}"
], getSpacing(60, "4x"), responsiveMediaQueries.tabletAndAbove, getSpacing("1x", "1x", "1x", 0));
export var StyledButton = styled(Button).withConfig({
    componentId: "sc-f8656eaa-6"
})([
    "text-align:center;min-width:256px;",
    "{min-width:288px;}"
], responsiveMediaQueries.desktopAndAbove);
